export default "__VITE_ASSET__47dedca7__"